<template>
  <div class="card" :class="{ 'card-tabled': this.tabled, 'card-tabled-mobile': this.tabledMobile }">
    <div class="card-header d-flex align-items-center" :class="getHeaderClass" v-if="hasSlot('header')">
      <slot name="header" />
      <a
        v-if="collapsible && !hideCaret"
        :aria-controls="id"
        :aria-expanded="open"
        :data-target="`#${id}`"
        :title="open ? 'Close' : 'Open'"
        data-toggle="collapse"
        href="#"
        @click.prevent="open = !open">
        <base-icon :icon="open ? 'caret-up' : 'caret-down'" />
      </a>
    </div>
    <template v-if="hasSlot('top')">
      <slot name="top" />
    </template>
    <div :class="{ 'show': open || !collapsible }" :id="id" class="collapse">
      <template v-if="hasSlot('body-top')">
        <div class="card-body-top">
          <slot name="body-top" />
        </div>
      </template>
      <div class="card-body" :class="bodyClass">
        <slot />
      </div>
      <template v-if="hasSlot('body-bottom')">
        <div class="card-body-bottom">
          <slot name="body-bottom" />
        </div>
      </template>
    </div>
    <template v-if="hasSlot('bottom')">
      <slot name="bottom" />
    </template>
    <template v-if="hasSlot('footer')">
      <div class="card-footer">
        <slot name="footer" />
      </div>
    </template>
    <div class="card-disabled" v-if="disabled"></div>
    <div class="card-loading" v-if="loading">
      <div class="d-flex align-items-center justify-content-center h-100 h1">
        <base-icon icon="spinner" spin />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    this.id = this.handler || `card-${this.$id.gen()}`
  },

  mounted () {
    if (this.collapsible) {
      this.registerEvents()
    }
  },

  data: () => ({
    id: null,
    open: false
  }),

  name: 'BaseCard',

  props: {
    bodyClass: String,
    closed: Boolean,
    collapsible: Boolean,
    design: { default: 'light', type: String },
    disabled: Boolean,
    handler: String,
    headerFlex: { default: 'justify-content-between', type: String },
    hideCaret: Boolean,
    loading: Boolean,
    tabled: Boolean,
    tabledMobile: Boolean
  },

  computed: {
    getHeaderClass () {
      const classes = {}

      classes[this.headerFlex] = true

      if (this.design) {
        classes['has-header-variant'] = !this.disabled

        classes['bg-danger'] = this.design === 'danger'
        classes['bg-info'] = this.design === 'info'
        classes['bg-primary'] = this.design === 'primary'
        classes['bg-secondary'] = this.design === 'secondary'
      }

      return classes
    }
  },

  methods: {
    hasSlot (slot) {
      return this.$_.get(this.$slots, slot) !== undefined
    },

    registerEvents () {
      $(`#${this.id}`)
        .on('show.bs.collapse', () => {
          this.open = true
          this.$emit('show')
        })
        .on('shown.bs.collapse', () => this.$emit('shown'))
        .on('hide.bs.collapse', () => {
          this.open = false
          this.$emit('hide')
        })
        .on('hidden.bs.collapse', () => this.$emit('hidden'))
    }
  },

  watch: {
    closed () {
      if (!this.closed && !this.open) {
        $(`#${this.id}`).collapse('show')
      }
    }
  }
}
</script>

<style lang="scss">
  .card {
    margin-bottom: 1.5rem
  }

  .card-header {
    min-height: 74px;

    &.has-header-variant {
      margin: -1px
    }
  }
</style>
